/* D2D PREVIEW: grid colour-name label that follows the hovered/tapped swatch */
(function(){
  if (window.__d2dColourName) return; window.__d2dColourName = true;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  function wrap(el){ return el && el.closest ? el.closest('.grid-product__colors') : null; }
  function label(w){ return w ? w.querySelector('.grid-product__color-name') : null; }
  function nameOf(s){ var v = s.querySelector('.visually-hidden'); return v ? v.textContent.trim() : ''; }
  function show(s){
    var w = wrap(s), l = label(w); if (!l) return;
    l.textContent = nameOf(s);
    w.querySelectorAll('.color-swatch').forEach(function(x){ x.classList.toggle('is-active', x === s); });
  }
  function reset(w){
    var l = label(w); if (!l) return;
    l.textContent = l.getAttribute('data-default');
    w.querySelectorAll('.color-swatch.is-active').forEach(function(x){ x.classList.remove('is-active'); });
  }
  var lastPointer = '';
  document.addEventListener('pointerdown', function(e){ lastPointer = e.pointerType || ''; }, true);
  if (!touch) {
    document.addEventListener('mouseover', function(e){
      if (lastPointer === 'touch') return; var s = e.target.closest && e.target.closest('.grid-product__colors .color-swatch'); if (s) show(s);
    });
    document.addEventListener('mouseout', function(e){
      if (lastPointer === 'touch') return; var w = wrap(e.target); if (!w) return;
      if (!e.relatedTarget || !w.contains(e.relatedTarget)) reset(w);
    });
    document.addEventListener('focusin', function(e){
      var s = e.target.closest && e.target.closest('.grid-product__colors .color-swatch'); if (s) show(s);
    });
  }
  /* Touch: first tap on a dot shows its name (and swaps the card image when the variant has one); a second tap on the same dot opens that colour */
  document.addEventListener('click', function(e){
    if (!(touch || lastPointer === 'touch')) return;
    var s = e.target.closest && e.target.closest('.grid-product__colors .color-swatch'); if (!s) return;
    if (s.classList.contains('is-active')) return;
    e.preventDefault(); show(s);
    var img = s.getAttribute('data-variant-image'), item = s.closest('.grid-product');
    if (img && item) {
      var pic = item.querySelector('.grid-product__image-mask img, .grid__image-ratio img, img');
      if (pic) { if (!pic.dataset.d2dOrig) { pic.dataset.d2dOrig = pic.currentSrc || pic.src; }
        pic.removeAttribute('srcset'); pic.src = img.indexOf('//') === 0 ? 'https:' + img : img; }
    }
  }, true);
})();

/* D2D level cards START: keep the full product title as a tooltip when the card title is clamped (18 Oct) */
(function(){
  if (window.__d2dTitleAttr) return; window.__d2dTitleAttr = true;
  function run(){ document.querySelectorAll('.grid-product__title:not([title])').forEach(function(t){ var s=(t.textContent||'').trim(); if(s) t.setAttribute('title', s); }); }
  var q; function later(){ clearTimeout(q); q=setTimeout(run,150); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(later).observe(document.documentElement,{childList:true,subtree:true});
})();
/* D2D level cards END */

/* D2D swatch colour map START (19 Oct): colour name as tooltip on every dot; log names with no mapped shade (they show neutral grey) */
(function(){
  if (window.__d2dSwatchTitles) return; window.__d2dSwatchTitles = true;
  window.d2dUnmappedSwatches = window.d2dUnmappedSwatches || [];
  function nameOf(s){ var v = s.querySelector('.visually-hidden'); return ((v ? v.textContent : s.textContent) || '').trim(); }
  function run(){
    document.querySelectorAll('.grid-product__colors .color-swatch:not([data-d2d-sw]), .variant-input-wrap label.color-swatch:not([data-d2d-sw])').forEach(function(s){
      s.setAttribute('data-d2d-sw','1'); var n = nameOf(s); if (!n) return;
      if (!s.getAttribute('title')) s.setAttribute('title', n);
      var cs = getComputedStyle(s);
      if (cs.backgroundColor === 'rgb(138, 133, 128)' && cs.backgroundImage === 'none' && window.d2dUnmappedSwatches.indexOf(n) < 0) {
        window.d2dUnmappedSwatches.push(n); if (window.console) console.info('[D2D] unmapped swatch colour (showing neutral grey):', n);
      }
    });
  }
  var q; function later(){ clearTimeout(q); q = setTimeout(run, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(later).observe(document.documentElement, {childList:true, subtree:true});
})();
/* D2D swatch colour map END */
